import styled, { css } from 'styled-components';

import StyledTypo from '@tmh-website/styles/typo';

import type { HeaderThemeColor } from '../Header.theme';
import { headerThemes } from '../Header.theme';

export type NavHighlightLinkState = 'selected' | 'child-selected' | undefined;

export const Container = styled.a<{ $themeColor: HeaderThemeColor; $state?: NavHighlightLinkState; ref?: any }>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  margin: -10px;
  margin-right: 30px;
  color: ${props => props.theme.color[headerThemes[props.$themeColor].subnav.text]};
  text-align: center;
  cursor: pointer;
  opacity: 0.6;
  transition: ${props => props.theme.transitionTiming};
  ${props =>
    props.$state &&
    css`
      opacity: 0.8 !important;
    `};

  &:hover {
    text-decoration: none;
    opacity: 0.8;
  }

  &:last-of-type {
    margin-right: 0;
  }

  > svg {
    flex-shrink: 0;
  }
`;

export const Label = styled(StyledTypo.Typography)`
  margin: 6px 0 0;
`;
